import config from 'config'
import React from 'react'
import { useSelector } from 'react-redux'
import MatrixMessageActionBar from 'matrix-react-sdk/lib/components/views/messages/MessageActionBar'
import { getRoomLinkUrl } from 'ducks/chat/utils/rooms'
import { isBotUser } from 'ducks/chat/utils/users'
import { selectIsReactionsEnabledForCurrentWidget } from 'ducks/widgets/selectors/widgets'

const permalinkCreator = {
  forEvent: (mxEvent, roomContext) => {
    return getRoomLinkUrl(roomContext.room, mxEvent)
  },
}

export default function MessageActionBar(props) {
  const {
    mxEvent: {
      sender: { userId },
    },
  } = props
  const isBot = isBotUser(userId)
  const reactionsEnabled = useSelector(selectIsReactionsEnabledForCurrentWidget)

  const visibleButtons = {
    showReactButton: reactionsEnabled && !isBot,
    showReplyButton: false,
    showEditButton: false,
    showRedactButton: false,
    showMenuButton: false,
    showAnchorButton: !isBot,
  }

  return (
    <MatrixMessageActionBar
      {...props} // eslint-disable-line react/jsx-props-no-spreading
      {...visibleButtons}
      emojiWidth={config.emojiWidth}
      emojiHeight={config.emojiHeight}
      permalinkCreator={permalinkCreator}
    />
  )
}
